export default "<app-new-offer [requestWaste]=\"true\"></app-new-offer>\n"